import { render, staticRenderFns } from "./idea.vue?vue&type=template&id=000bbe83&scoped=true&"
import script from "./idea.vue?vue&type=script&lang=js&"
export * from "./idea.vue?vue&type=script&lang=js&"
import style0 from "./idea.vue?vue&type=style&index=0&id=000bbe83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bbe83",
  null
  
)

export default component.exports